import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=37e8e9aa&scoped=true"
import script from "./sport.vue?vue&type=script&lang=js"
export * from "./sport.vue?vue&type=script&lang=js"
import style0 from "./sport.vue?vue&type=style&index=0&id=37e8e9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8e9aa",
  null
  
)

export default component.exports